// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2K9Qa","actions":"GroupTable_actions__-mCpv","deleteModalFooter":"GroupTable_deleteModalFooter__1-77a"};